import { useSubscribe, useFetchSubscriptionList } from '___queries'

export const useSubscriptions = () => {
  const subscribe = useSubscribe()
  const subscriptionList = useFetchSubscriptionList()
  return { subscribe, subscriptionList }
}

export default useSubscriptions
